export const autocompleteChainSelectorHelperStyles = {
    listBoxProps: {
        maxHeight: '160px',
        overflowY: 'auto',
    },
};
